const apiUrl = process.env.REACT_APP_API_URL;

export const GetUserTrades = async (userId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trades/${userId}`);
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error fetching trades:', error);
        return [];
    }
};

export const SendTradeRequest = async (senderId: number, receiverId: number, javamonSenderId: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trades`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sender_id: senderId, receiver_id: receiverId, javamon_sender_id: javamonSenderId })
        });
        return response.ok;
    } catch (error) {
        console.log('Error sending trade request:', error);
        return false;
    }
};

export const ProposeTrade = async (tradeId: number, javamonReceiverId: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trades/${tradeId}/propose`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ javamon_receiver_id: javamonReceiverId })
        });
        return response.ok;
    } catch (error) {
        console.log('Error proposing trade:', error);
        return false;
    }
};

export const AcceptTrade = async (tradeId: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trades/${tradeId}/accept`, {
            method: 'POST'
        });
        return response.ok;
    } catch (error) {
        console.log('Error accepting trade:', error);
        return false;
    }
};

export const RejectTrade = async (tradeId: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trades/${tradeId}/reject`, {
            method: 'POST'
        });
        return response.ok;
    } catch (error) {
        console.log('Error rejecting trade:', error);
        return false;
    }
};

export const GetAllUsers = async (userId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/same-aula/${userId}`);
        return await response.json();
    } catch (error) {
        console.log('Error fetching users:', error);
        return [];
    }
};
